<div #input #origin="ttAutocompleteOrigin" class="tag-grid-with-input" role="presentation" ttAutocompleteOrigin ttInput [error]="_error()">
  <div class="tag-grid-with-input_option-list">
    @for (option of _userAddedOptions(); track option) {
      <span class="tag-grid-with-input_option" [ttTooltip]="option">
        <span>{{ option }}</span>
        <button type="button" (click)="removeTag($event, option)"><mat-icon [icon]="'x'" [iconSize]="14" /></button>
      </span>
    }
    <input type="text" [formControl]="searchControl" [placeholder]="_placeholder()" (keydown)="onInputChange($event)" />
  </div>
</div>
